import React, { useState } from 'react';

function LogoImage({ ticker, companyName, size }) {
  const [failed, setFailed] = useState(false);
  const apiBase = (process.env.REACT_APP_API_BASE_URL || '/api').replace(/\/$/, '');
  return (
    <span
      aria-hidden="true"
      style={{
        width: size, height: size, minWidth: size, display: 'inline-flex',
        alignItems: 'center', justifyContent: 'center', verticalAlign: 'middle',
        borderRadius: 8, background: '#f1f5f9', color: '#475569',
        overflow: 'hidden', flexShrink: 0, fontSize: size < 32 ? 10 : 12,
        fontWeight: 700, border: '1px solid #e2e8f0',
      }}
    >
      {!failed && ticker ? (
        <img
          src={`${apiBase}/company-logo/${encodeURIComponent(ticker)}`}
          alt=""
          title={`${companyName || ticker} logo`}
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
          style={{ width: '100%', height: '100%', objectFit: 'contain', padding: 4, boxSizing: 'border-box' }}
        />
      ) : ticker.slice(0, 2) || '?'}
    </span>
  );
}

export default function StockLogo({ ticker, companyName, size = 36 }) {
  const symbol = String(ticker || '').trim().toUpperCase();
  // A new symbol gets fresh image state after a previous stock's image failed.
  return <LogoImage key={symbol} ticker={symbol} companyName={companyName} size={size} />;
}
